import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    padding: "37px",
    minHeight: "100%",
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(3),
  },
  requiredText: {
    color: theme.palette.warning.main,
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    fontSize: theme.spacing(2),
    color: theme.palette.text.secondary,
    cursor: "help",
    marginLeft: theme.spacing(1),
  },
  inputBackgroundColor: {
    backgroundColor: "#F4F4F4",
  },
  inputDescription: {
    backgroundColor: "#F4F4F4",
    borderRadius: "4px",
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    paddingLeft: "10px",
    paddingRight: "10px",
    "&.Mui-focused": {
      backgroundColor: "rgba(0, 0, 0, 0.09)",
    },
  },
  autocompleteRoot: {
    paddingTop: "0 !important",
  },
  underline: {
    "&:before": {
      borderBottomStyle: "none",
    },
  },
  mediaKey: {
    opacity: 0.4,
    fontStyle: "italic",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: "0.75rem",
  },

  thumbnailContainer: {
    width: "48%",
    [theme.breakpoints.down("md")]: {
      width: "33%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  thumbnailSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      justifyContent: "start",
      gap: 40,
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between",
      gap: 0,
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
  },
  twoFieldContainer: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      gap: 20,
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 0,
    },
  },
  dateTime: {
    position: "relative",
    [theme.breakpoints.down("md")]: {
      top: "-7px",
    },
    [theme.breakpoints.down("sm")]: {
      top: 0,
    },
  },
}))

export default styles
